import { getCookie } from './tabs';

/* eslint-disable import/prefer-default-export */
export const initCookieBlock = () => {
  const cookieBlock = document.querySelector('.js-cookieblock');
  if (!cookieBlock) return;
  if (getCookie('cookieAccept') !== 'yes') {
    cookieBlock.classList.add('is-active');
  }

  const button = document.querySelector('.js-cookie-hide');
  button.addEventListener('click', () => {
    document.cookie = 'cookieAccept=yes; max-age=6000000';
    cookieBlock.classList.remove('is-active');
  });
};
